/**
 * @link https://contactform7.com/dom-events/
 * List of Contact Form 7 Custom DOM Events
 wpcf7invalid — Fires when an Ajax form submission has completed successfully, but mail hasn’t been sent because there are fields with invalid input.
 wpcf7spam — Fires when an Ajax form submission has completed successfully, but mail hasn’t been sent because a possible spam activity has been detected.
 wpcf7mailsent — Fires when an Ajax form submission has completed successfully, and mail has been sent.
 wpcf7mailfailed — Fires when an Ajax form submission has completed successfully, but it has failed in sending mail.
 wpcf7submit — Fires when an Ajax form submission has completed successfully, regardless of other incidents.

 * PROPERTY	DESCRIPTION
 detail.contactFormId	The ID of the contact form.
 detail.pluginVersion	The version of Contact Form 7 plugin.
 detail.contactFormLocale	The locale code of the contact form.
 detail.unitTag	The unit-tag of the contact form.
 detail.containerPostId	The ID of the post that the contact form is placed in.
 */

jQuery(document).ready(function ($) {

	"use strict";
	if ($('.karrier_form form').length) {
		var hideden_select = $('#hideden_select .wpcf7-hidden'); //
		var hidden_subject = $('#subject_field .wpcf7-hidden');
		var old_select = $('#job_select').val(); //
		var old_title = hidden_subject.val();
		$(document).on("change", ".swipe_toggle input", function () {
			// CHANGED THIS SELECTOR
			if ($('.swipe_toggle input').is(':checked')) {
				hidden_subject.val('Initiativbewerbung')
			} else {
				hidden_subject.val(old_title)
			}
		});
		hideden_select.val(old_select);
		$("#job_select").on("change", function () {
			hideden_select.val($(this).val())
		});
	}

	document.addEventListener('wpcf7submit', function (event) {
		"use strict";
		if (522 === event.detail.contactFormId) {
			console.log(event.detail.contactFormId);
			hidden_subject.val(old_title)
		}
	}, false);
});
